<p-toast></p-toast>

<p-sidebar [(visible)]="showDriversCompaignExportSidebar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'580px'}">
    <ng-template pTemplate="header">Export data</ng-template>

    <div>
        <p-scrollPanel [style]="{height: 'calc(100vh - 170px)'}">
            <div class="mt-3">
                <div class="flex flex-column mt-2">
                    <label class="export-data-label mb-2">File Type</label>
                    <p-dropdown [options]="fileTypes" placeholder="Please Select" [showClear]="true"
                                optionLabel="name" optionValue="value" [(ngModel)]="exportData.fileType"></p-dropdown>
                </div>
            </div>

            <!--<div class="mt-4">
            <div class="export-data-title">Data</div>
            <div class="export-data-subtitle mt-2">Select date you want to include</div>

            <div class="flex flex-row">
                <div class="w-50-percent">
                    <div class="mt-2">
                        <p-checkbox label="First Name" name="dataFieldGroup" [value]="dataFieldEnum.FirstName" [(ngModel)]="selectedDataFields"></p-checkbox>
                    </div>
                    <div class="mt-2">
                        <p-checkbox label="Last Name" name="dataFieldGroup" [value]="dataFieldEnum.LastName" [(ngModel)]="selectedDataFields"></p-checkbox>
                    </div>
                    <div class="mt-2">
                        <p-checkbox label="Mobile Number" name="dataFieldGroup" [value]="dataFieldEnum.MobileNumber" [(ngModel)]="selectedDataFields"></p-checkbox>
                    </div>
                    <div class="mt-2">
                        <p-checkbox label="Date" name="dataFieldGroup" [value]="dataFieldEnum.Date" [(ngModel)]="selectedDataFields"></p-checkbox>
                    </div>
                </div>

                <div class="w-50-percent">
                    <div class="mt-2">
                        <p-checkbox label="Acceptance Rate" name="dataFieldGroup" [value]="dataFieldEnum.AcceptanceRate" [(ngModel)]="selectedDataFields"></p-checkbox>
                    </div>
                    <div class="mt-2">
                        <p-checkbox label="Cancellation Rate" name="dataFieldGroup" [value]="dataFieldEnum.CancellationRate" [(ngModel)]="selectedDataFields"></p-checkbox>
                    </div>
                    <div class="mt-2">
                        <p-checkbox label="Number of Transactions" name="dataFieldGroup" [value]="dataFieldEnum.NumberOfTransactions" [(ngModel)]="selectedDataFields"></p-checkbox>
                    </div>
                </div>
            </div>

            <div class="flex flex-row mt-3">
                <div class="w-50-percent">
                    <div class="export-data-subtitle">Time Online</div>

                    <div class="mt-2">
                        <p-checkbox label="Start of Rider Online" name="dataFieldGroup" [value]="dataFieldEnum.StartRiderOnline" [(ngModel)]="selectedDataFields"></p-checkbox>
                    </div>
                    <div class="mt-2">
                        <p-checkbox label="End of Rider Online" name="dataFieldGroup" [value]="dataFieldEnum.EndRiderOnline" [(ngModel)]="selectedDataFields"></p-checkbox>
                    </div>
                </div>

                <div class="w-50-percent">
                    <div class="export-data-subtitle">Location History</div>

                    <div class="mt-2">
                        <p-checkbox label="Picked up" name="dataFieldGroup" [value]="dataFieldEnum.PickedUp" [(ngModel)]="selectedDataFields"></p-checkbox>
                    </div>
                    <div class="mt-2">
                        <p-checkbox label="Dropped Off" name="dataFieldGroup" [value]="dataFieldEnum.DroppedOff" [(ngModel)]="selectedDataFields"></p-checkbox>
                    </div>
                </div>
            </div>
        </div>-->
        </p-scrollPanel>

        <div class="flex justify-content-end mrg-10-0px" *ngIf="!loading">
            <button class="btn-darkblue" pButton label="Download" (click)="clickDownload()"></button>
        </div>
        <div *ngIf="loading" style="text-align: center;">
            <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" strokeWidth="5" fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
        </div>
    </div>

</p-sidebar>